import React, { FC } from 'react';

import { useNotifications } from '../../hooks/useNotifications';
import { ModalContainer } from './ModalContainer';
import { ToastContainer } from './ToastContainer';

export const NotificationsContainer: FC = () => {
  const { notifications } = useNotifications();

  if (!notifications) {
    return null;
  }

  return (
    <>
      <ToastContainer />
      <ModalContainer />
    </>
  );
};
